import Icon from "app/components/UI/Icon";
import Link from "app/components/UI/Link";
import PropTypes from "prop-types";
import React from "react";
import classes from "./PreviousLink.module.css";
import classnames from "classnames";

export const PreviousLink = ({ className, children, ...props }) => (
  <Link className={classnames(className, classes.previousLink)} {...props}>
    <Icon className={classes.iconLeft}>chevron_left</Icon>
    {children}
  </Link>
);

PreviousLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default PreviousLink;



// WEBPACK FOOTER //
// ./src/app/components/UI/PreviousLink/PreviousLink.js